import React, { ReactElement } from "react";
import { ToelichtingPensioenHoofdstuk } from "../../../../../.generated/rapportage/rapportagetypes";
import { Chapter } from "../../../components/Chapter";
import { PageBreak } from "../../../components/PageBreak";
import Heading from "../../../components/Heading";
import { Paragraph } from "../../../components/Paragraph";
import { ScenarioPensioenChapter } from "./scenario-pensioen-chapter";

type ToelichtingPensioenChapterProps = {
  hoofdstuk: ToelichtingPensioenHoofdstuk;
};

export const ToelichtingPensioenChapter = ({
  hoofdstuk,
}: ToelichtingPensioenChapterProps): ReactElement => {
  const toonAanvrager1 = hoofdstuk.motivering?.some(
    (x) => x.klantVolgnummer === 1
  );
  const toonAanvrager2 = hoofdstuk.motivering?.some(
    (x) => x.klantVolgnummer === 2
  );
  return (
    <>
      <PageBreak />
      <Chapter>
        <Heading level={2} text={hoofdstuk.titel} />
        <Paragraph paragraaf={hoofdstuk.paragrafen?.p3060601} />
        {toonAanvrager1 && (
          <ScenarioPensioenChapter
            scenarioPensioen={hoofdstuk}
            selectedAanvrager="Aanvrager1"
          />
        )}

        {toonAanvrager2 && (
          <>
            {toonAanvrager1 && <PageBreak />}
            <ScenarioPensioenChapter
              scenarioPensioen={hoofdstuk}
              selectedAanvrager="Aanvrager2"
            />
          </>
        )}
      </Chapter>
    </>
  );
};
